import { getStorage, setStorage } from '@/tools/storage';

const project = {
  namespaced: true,
  state: {
    // 甲方id
    enterprise_id: getStorage('industryEnterpriseId')
    // 审核状态
  },
  getters: {
    hasEnterprise: state => +state.enterprise_id > 0
  },
  mutations: {
    SET_ENTERPRISE_ID: (state, id) => {
      state.enterprise_id = id;
      setStorage('industryEnterpriseId', id);
    }
  }
};

export default project;
